module.exports = __webpack_public_path__ + "media/images/athletes/4336-59690fd7b0fb425580bd0fc24022b369.png";